import * as React from 'react';

export function SearchIcon2(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<path d='m21 21-4.34-4.34' />
			<circle cx='11' cy='11' r='8' />
		</svg>
	);
}
